import { schema } from 'normalizr';

const getAccountGOSTsAssignments = new schema.Entity('accountGOSTsAssignments');

export default getAccountGOSTsAssignments;
